// ============================================================
// Braval - Search Bar Component
// ============================================================

import React from 'react';
import { Link } from 'react-router-dom';

export default function SearchBar({ searchTerm, setSearchTerm, onSearch, loading }) {

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') onSearch();
    };

    return (
        <div className="search-bar">
            <input
                type="text"
                className="search-input"
                placeholder="Search by description or title..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                onKeyDown={handleKeyDown}
            />
            <button
                className="search-button"
                onClick={onSearch}
                disabled={loading}
            >
                {loading ? 'Searching...' : 'Search'}
            </button>
            <Link to="/lots/new" className="search-button new-lot-button">
                + New Lot
            </Link>
        </div>
    );
}